import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MoreVertical, Flag, Sparkles } from "lucide-react";
import BusinessReportModal from "./BusinessReportModal";
import GallyoInsiderModal from "./GallyoInsiderModal";
import { reportBusiness } from "../../services/business";

function Card({ item, type }) {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showInsiderModal, setShowInsiderModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigateToBusiness = () => {
    navigate(`/business/${item.slug}/${item.place_id}`);
    return;
  };

  const handleReport = async (reason) => {
    try {
      setIsLoading(true);
      const payload = {
        reason: reason,
        reported_business: item.business_id,
      };
      await reportBusiness(payload);
      console.log("payload", payload);
    } catch (error) {
      console.error("Error while reporting business: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="flex flex-col border shadow-sm rounded-lg relative">
        <div className="relative h-[180px] w-full rounded-t-lg overflow-hidden">
          <img
            src={item.imageUrl || "/image/discover-list.png"}
            alt={item.name}
            className="w-full h-full object-cover"
          />

          {/* Options Menu Button - show for all businesses */}
          <div className="absolute top-2 right-2">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowMenu(!showMenu);
              }}
              className="p-1.5 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              <MoreVertical className="h-4 w-4 text-gray-700" />
            </button>

            {/* Dropdown Menu */}
            {showMenu && (
              <div className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-10">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowMenu(false);
                    setShowReportModal(true);
                  }}
                  className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                >
                  <Flag className="h-4 w-4" />
                  <span>Report business</span>
                </button>
              </div>
            )}
          </div>
        </div>

        <div onClick={navigateToBusiness} className="cursor-pointer mt-2 p-2">
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center flex-1 min-w-0">
              <h3 className="font-medium text-sm text-gray-800 truncate pr-1">
                {item.name}
              </h3>
              {/* Verified Badge - positioned right next to the name like Facebook */}
              {item.is_registered && (
                <div className="flex-shrink-0 ml-1 relative group">
                  <img
                    src={"/vbadge.svg"}
                    alt="Verified"
                    className="w-8 h-8 sm:w-8 sm:h-8 cursor-pointer"
                  />
                  {/* Tooltip */}
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-[#7B189F] text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10">
                    Verified
                    {/* Tooltip arrow */}
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-l-4 border-r-4 border-t-4 border-transparent border-t-purple-600"></div>
                  </div>
                </div>
              )}
            </div>

            {/* Own This? Verify Button - only show if NOT verified */}
            {!item.is_registered && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setShowInsiderModal(true);
                }}
                className="text-xs text-purple-600 hover:text-purple-700 border border-dashed border-purple-300 hover:border-purple-400 px-2 py-1 rounded transition-all duration-200 ml-2 flex-shrink-0 whitespace-nowrap"
              >
                Own This? Verify
              </button>
            )}
          </div>

          <div className="flex items-center mt-1 space-x-2">
            <div className="flex items-center bg-purple-100 px-2 py-1 rounded-sm">
              <img
                src="/images/location.png"
                alt="Location"
                className="w-3 h-3"
              />
              <span className="text-xs text-purple-700 ml-1">
                {item.distance === "NaN"
                  ? ((Math.random() * 10) % 2).toFixed(2)
                  : item.distance}{" "}
                miles
              </span>
            </div>
            {item.rating && (
              <div className="flex items-center bg-green-100 px-3 py-1 rounded-sm">
                <span className="text-amber-500 mr-0.5">★</span>
                <span className="text-xs font-medium">{item.rating}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Report Modal */}
      <BusinessReportModal
        isOpen={showReportModal}
        onClose={() => setShowReportModal(false)}
        onReport={handleReport}
        businessName={item.name}
      />

      {/* Gallyo Insider Modal */}
      <GallyoInsiderModal
        business={item}
        isOpen={showInsiderModal}
        onClose={() => setShowInsiderModal(false)}
      />
    </>
  );
}

export default Card;
